import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import {
  isLogged,
  getRole,
  isMounted,
  userHasBusiness,
  userHasDealer
} from '~/state/modules/user'

import { ROLES, RolesUnion } from '~/constants/roles'

import Paths from './paths'

export interface WithAuthProps {
  isLogged: boolean
}

const withAuth = (access?: RolesUnion[]) => (Page: any) => () => {
  const userType = useSelector(getRole)
  const logged = useSelector(isLogged)
  const mounted = useSelector(isMounted)
  const hasBusiness = useSelector(userHasBusiness)
  const hasDealer = useSelector(userHasDealer)

  const { pathname, push } = useRouter()

  useEffect(() => {
    const role = userType || ROLES.guest

    if (mounted) {
      if (logged) {
        if (access && !access.includes(role)) push('/')
        else if (pathname.includes(Paths.auth.signIn)) push(Paths.account.ads)
        else if (pathname.includes(Paths.businessess.new) && hasBusiness)
          push('/')
        else if (pathname.includes(Paths.dealer.new) && hasDealer) push('/')
      } else if (access && !access.includes(role)) {
        push('/')
      } else if (pathname.includes('/account')) {
        push('/')
      }
    }
  }, [userType, logged, mounted])

  return <Page isLogged={logged} />
}

export { ROLES } from '~/constants/roles'
export default withAuth
